// =====================================================================
// CONSTANTS: quiz-api-urls.ts
// FUNCTIONAL OVERVIEW:
//   Single place for every Quiz endpoint (JHUD-5314). The conversational
//   stream is served by the chat orchestrator; all REST endpoints are
//   served by knowledge-check-service.
// =====================================================================
import { CHAT_CONTEXT, KNOWLEDGE_CHECK_CONTEXT } from './api-context';

const KC = KNOWLEDGE_CHECK_CONTEXT;

export const QUIZ = {
  CHAT_STREAM: `${CHAT_CONTEXT}quiz/chat`,
  SESSIONS: `${KC}quiz/sessions`,
  SESSION: (id: number) => `${KC}quiz/sessions/${id}`,
  ANSWERS: (id: number) => `${KC}quiz/sessions/${id}/answers`,
  CONTINUE: (id: number) => `${KC}quiz/sessions/${id}/questions/continue`,
  COMPLETE: (id: number) => `${KC}quiz/sessions/${id}/complete`,
  EXPORTS: (id: number) => `${KC}quiz/sessions/${id}/exports`,
  EXPORT: (exportId: number) => `${KC}quiz/exports/${exportId}`,
  EXPORT_DOWNLOAD: (exportId: number) => `${KC}quiz/exports/${exportId}/download`,
  HISTORY: `${KC}quiz/history`,
  HISTORY_DETAIL: (id: number) => `${KC}quiz/history/${id}`,
  CHAT_HISTORY: `${KC}quiz/chat-history`,
};
